import { Button } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/Footer/Footer";
import AOS from "aos";
import "aos/dist/aos.css";

import styles from "./AgnecyLanding.module.css";
import Intro from "./Intro/Intro";
import Hero from "./Hero/Hero";
import Services from "./Services/Services";
import Portfolio from "./Portfolio/Portfolio";
import Cta from "./CTA/cta";
import MainServices from "../../../components/MainService/MainService";

function AgnecyLanding() {
  const navigate = useNavigate();

  const handleSignUp = () => {
    navigate(`/agency-onbaord`);
  };

  useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: "ease-out-cubic",
      });
    };

    window.addEventListener("load", () => {
      aos_init();
    });
  }, []);

  // useDocTitle("MLD | Molad e Konsult - Bespoke Web and Mobile Applications");

  return (
    <div className="primary-wrapper">
      <Navbar />
      <div className={styles.bodyContainer}>
        <div className={styles.innerBodyContainer}>
          {/* <div className={styles.bodyContainer}>
          <div>This is a landing page for Agency</div>
          <Button onClick={handleSignUp}>Sign Up</Button>
        </div>
        <div className={styles.bodyContainer}> */}
          {/* <div>Thsi is a landing page for realtors</div>
        <Button onClick={handleSignUp}>Sign Up</Button> */}
          {/* </div> */}
          <Hero />
          <Intro />
          <MainServices />
          <Portfolio />
          <Cta />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AgnecyLanding;
